<template>
  <div class="home-mobile" style="width: 100%;">
    <div style="width: 100%; height: 100px;"></div>
    <div style="position: absolute;width: 100%;height: 300px; display: flex;justify-content: center;">
      <Title style="width: 90%;"></Title>
    </div>
    <div class="home-mobile__nav">
      <div class="home-mobile__grid">
        <div class="home-mobile__cell">
          <my-button-mobile
            title="乐器练习"
            href="Sound"
            bg-color="linear-gradient(90deg, rgb(39, 122, 218), rgb(74, 230, 121), rgb(243, 169, 10), rgb(226, 20, 233), rgb(16, 172, 219))"
          ></my-button-mobile>
        </div>
        <div class="home-mobile__cell">
          <my-button-mobile
            title="团队视频"
            href="ShowVideo"
            bg-color="linear-gradient(90deg, #fc6076, #ff9a44, #ef9d43, #e75516)"
          ></my-button-mobile>
        </div>
        <div class="home-mobile__cell">
          <my-button-mobile
            title="乐声播放"
            href="MusicList"
            bg-color="linear-gradient(90deg,#009245, #FCEE21, #00A8C5, #D9E021)"
          ></my-button-mobile>
        </div>
        <div class="home-mobile__cell">
          <my-button-mobile
            title="VR接入"
            href="VrGuide"
            bg-color="linear-gradient(90deg, #00c6fb, #005bea, #00d2ff, #3a7bd5)"
          ></my-button-mobile>
        </div>
        <div class="home-mobile__cell home-mobile__cell--wide">
          <my-button-mobile
            title="更多"
            href="MoreMobile"
            bg-color="linear-gradient(90deg, #667eea, #764ba2, #6B8DD6, #8E37D7)"
          ></my-button-mobile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/TitleMobile.vue'
import MyButtonMobile from '@/components/MyButtonMobile.vue'
export default {
  name: 'Home',
  components: {
    MyButtonMobile,
    Title
  }
}
</script>

<style lang="less" scoped>
.home-mobile__nav {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 175px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.home-mobile__grid {
  width: 95%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 12px;
  justify-items: center;
  align-items: center;
}
.home-mobile__cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-mobile__cell--wide {
  grid-column: 1 / -1;
}
</style>
